









import {Vue, Component, Prop} from "vue-property-decorator";

@Component({
  name: "Dialog",
})
export default class Dialog extends Vue {
  @Prop({default: 100})
  private width!: number;
  private showOverlay: boolean = false;

  private get dialogStyle() {
    return `width: ${this.width}vh; width: calc(var(--vh, 1vh) * ${this.width});`;
  }


  private created() {
    this.showOverlay = false;
  }

  private mounted() {
    this.showOverlay = true;
  }

  private beforeDestroy() {
    this.showOverlay = false;
  }

  private clickOutside() {
    this.$emit("dialog:clickOutside");
  }


}
